import React from 'react';
import classNames from 'classnames';

interface IProps {
	className?: string;
	size?: string;
}

const Spinner: React.FC<IProps> = ( props: IProps ) => {
	if (props.size === 'full-page') {
		return (
			<div className="wrapper">
				<span className={classNames('spinner', props.className)} />
			</div>
		);
	}
	return  <span className={classNames('spinner', props.className)} />;
};

export default Spinner;
